import { useState, useEffect } from "react";
import axiosInstance from "../../utils/axiosInstance";
import UsersTab from "../UsersTab";
import { useTranslation } from 'react-i18next';

const UsersPage = () => {
  const { t } = useTranslation();

  const [users, setUsers] = useState([]);

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const response = await axiosInstance.get("/users");
      setUsers(response.data);
    } catch (error) {
      console.error("Помилка отримання користувачів:", error);
    }
  };

  return (
    <div className="container mt-5">
      <div className="mt-4 d-flex justify-content-center">
      <a href="/admin/addnewuser" className="btn btn-success">{t("add")} {t("user").toLocaleLowerCase()}</a>
      </div>
      <UsersTab users={users} fetchUsers={fetchUsers} />
   
   
    </div>
    
    
  );
};

export default UsersPage;
